import _extends from "@babel/runtime/helpers/esm/extends";
import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M19.146 5.56l.799.8c.002 0 .055.13.055.135v4.81c0 .008-.052.133-.06.141l-9.232 9.231a1.005 1.005 0 0 1-1.415.002l-5.972-5.972a1 1 0 0 1 .002-1.415l9.23-9.231A.803.803 0 0 1 12.709 4H17.5a.5.5 0 0 0 0-1h-4.792c-.28 0-.663.155-.862.354l-9.23 9.23a2 2 0 0 0-.002 2.83l5.972 5.972c.781.781 2.053.775 2.83-.002l9.23-9.23c.196-.196.354-.574.354-.849v-4.81c0-.274-.16-.656-.348-.843l-.798-.798 2.792-2.792a.506.506 0 0 0 0-.708.504.504 0 0 0-.707 0L15.5 7.792a.506.506 0 0 0-.001.708c.195.195.516.19.708 0l1.15-1.15a1.75 1.75 0 1 1-2.777-.405.5.5 0 1 0-.708-.708 2.75 2.75 0 1 0 4.211.386l1.062-1.062z"
});

var SvgCoupons = function SvgCoupons(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default SvgCoupons;